module.exports = __webpack_public_path__ + "img/20.838dd29f.png";